








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryUserWealthRecordList,ExportUserWealthRecord } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditDistributionActivityDialog from './EditDistributionActivityDialog.vue'
import {WealthTypeFormat,WealthWayTypeFormat,WealthStatusFormat} from '@/utils/tyepconvert'
import constant from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class VideoList extends Vue {
  private queryParam:any = {
    startRow: 1,
    limit: 10,
    type: undefined,
    createTimeDaterange :[],
    finishTimeDaterange :[],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '用户ID', param: 'userId' },
    { title: '用户名称', param: 'userName' },
    { title: '关联号', param: 'recordNo' },
    { title: '财富类型', param: 'type', type: 'select', selectData: constant.WealthType },
    { title: '途径类型', param: 'wayType', type: 'select', selectData: constant.WealthWayType },
    { title: '状态', param: 'status', type: 'select', selectData: constant.WealthStatus },
    { title: '入帐时间 ', param: 'finishTimeDaterange', type: 'daterange', },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange', }

  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'primary', click: this.exportOrderHandle},
  ]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户ID', param: 'userId' },
    { title: '用户名称', param: 'userName' },
    { title: '手机号', param: 'mobilePhone' },
    { title: '财富类型', param: 'type', formatter: WealthTypeFormat},
    { title: '数量', param: 'qty' },
    { title: '应得数量', param: 'shouldQty' },
    { title: '关联号', param: 'recordNo'},
    { title: '途径类型', param: 'wayType', formatter: WealthWayTypeFormat},
    { title: '状态', param: 'status', formatter: WealthStatusFormat},
    { title: '入帐时间', width: 160 , param: 'finishTime', formatter: DateFormat},
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat},
    { title: '备注', param: 'note'},

  ]

  public async created() {
    this.applyRouteQuery()
    this.loadData()
  }

  // 每次显示的时候查询下
  public activated(){
    this.applyRouteQuery()
    this.loadData()
  }

  private applyRouteQuery() {
    const q = this.$route.query
    if (q.finishTime) {
      this.queryParam.finishTimeDaterange = [q.finishTime + ' 00:00:00', q.finishTime + ' 23:59:59']
    }
    if (q.type) {
      this.queryParam.type = Number(q.type)
    }
    if (q.wayType) {
      this.queryParam.wayType = Number(q.wayType)
    }
  }



  private exportOrderHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出用户积分记录',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      ExportUserWealthRecord(param,"用户积分记录.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserWealthRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam(){
     const param: any = { ...this.queryParam }
    if (param.createTimeDaterange.length >0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    if (param.finishTimeDaterange.length >0) {
      param.finishTimes = DateFormat(param.finishTimeDaterange[0]) + ',' + DateFormat(param.finishTimeDaterange[1])
    }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
